// @flow
import * as React from 'react'
import CategoryPillButton from '@components/blog/CategoryPillButton'
import type { BlogPostType } from '../../services/contentfulPosts'
import { Col, Row, config, Hidden } from 'react-awesome-styled-grid'
import styled from 'styled-components'
import { H250, P16 } from '@components/shared'
import { colors } from '@components/shared/colors'
import { FadeInImage } from '@components/shared/FadeInImage'
import { contentfulLoader } from '../../services/images'
import { LinkWithUtms } from '../../actions/navigationActions'

type PropsType = {
  post: BlogPostType
}
export default function FeaturedBlog (props: PropsType): React.Node {
  const { post } = props
  const categories = (
    post.categories || []
  ).map((cat: any, index: number): React.Node => (
    <CategoryPillButton key={`${index}-category-featured`} category={cat} />
  ))

  return (
    <RowHover>
      <Col
        xs={4}
        sm={8}
        md={4}
        lg={5}
        offset={{ lg: 1, xl: 1 }}
        align={'center'}
        justify={'center'}
      >
        <PostImageContainer>
          {post.postPhoto && (
            <LinkWithUtms pathname={`/blog/${post.slug}`}>
              <PostImage>
                {post.postPhoto && (
                  <FadeInImage
                    loader={contentfulLoader}
                    src={post.postPhoto.file.url}
                    width={post.postPhoto.file.details.image.width}
                    height={post.postPhoto.file.details.image.height}
                  />
                )}
              </PostImage>
            </LinkWithUtms>
          )}
        </PostImageContainer>
      </Col>
      <Col xs={4} md={4} lg={5} justify={'center'}>
        <ContentContainer>
          <PillContainer>{categories}</PillContainer>
          <TitleContainer>
            <LinkWithUtms pathname={`/blog/${post.slug}`}>
              <H250 color={colors.sand} styles={`cursor: pointer;`}>
                {post.title}
              </H250>
            </LinkWithUtms>
          </TitleContainer>
          <ExcerptContainer>
            <P18 color={colors.sand}>{post.excerpt}</P18>
          </ExcerptContainer>
          <Hidden xs={true} sm={true}>
            <AuthorContainer>
              <P16 color={colors.sand}>
                <b>{post.author?.authorName}</b>
                <span style={{ marginLeft: '10px', marginRight: '10px' }}>
                  |
                </span>
                {post.date}
              </P16>
            </AuthorContainer>
          </Hidden>
        </ContentContainer>
      </Col>
    </RowHover>
  )
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const PostImage = styled.div`
  width: 100%;
  border-radius: 10px;
  cursor: pointer;
  img {
    transition: transform 1s ease;
  }
  
  ${(props: any): string => config(props).media.md`
    width: 343px;
  `}

  ${(props: any): string => config(props).media.lg`
    width: 385px;
  `}

  ${(props: any): string => config(props).media.xl`
    width: 563px;
  `}
`

const PillContainer = styled.div`
  margin-bottom: 10px;
  margin-top: 20px;

  ${(props: any): string => config(props).media.lg`
    margin-bottom: 20px;
  `}

  ${(props: any): string => config(props).media.xl`
    margin-bottom: 25px;
  `}
`
const TitleContainer = styled.div`
  margin-bottom: 10px;

  ${(props: any): string => config(props).media.lg`
    margin-bottom: 15px;
  `}
`
const ExcerptContainer = styled.div``
const AuthorContainer = styled.div`
  margin-top: 25px;
`

const P18 = styled.p`
  color: ${(props: any): string => props.color || colors.white};
  font-family: 'Good Sans Light';
  font-style: normal;
  font-weight: ${(props: any): number => props.fontWeight || 300};
  letter-spacing: ${(props: any): number => props.letterSpacing || 0};
  text-align: ${(props: any): string => props.textAlign || 'left'};
  margin: ${(props: any): string => props.margin || '0'};;
  font-size: 16px;
  line-height: 24px;

  ${(props: any): string => config(props).media.sm`
     font-size: 16px;
    line-height: 24px;
  `}

  ${(props: any): string => config(props).media.lg`
     font-size: 18px;
    line-height: 27px;
  `}

  ${(props: any): ?string => props.styles}
`

const RowHover = styled(Row)`
  &:hover {
    img {
      transform: scale(1.1);
    }
  }
`

const PostImageContainer = styled.div`
 overflow: hidden;
 width: 100%;
 border-radius: 10px;
 margin-bottom: 15px;

  ${(props: any): string => config(props).media.md`
    width: 343px;
  `}

  ${(props: any): string => config(props).media.lg`
    width: 385px;
  `}

  ${(props: any): string => config(props).media.xl`
    width: 563px;
  `}
`
